export function init() {
    const links = document.querySelectorAll('.js-open-tabcontent');

    if (!links.length)
        return;

    const firstLink = links[0];
    firstLink.classList.add('active');

    const firstTabContent = document.getElementById(firstLink.dataset.tabId);
    firstTabContent.classList.add('active');
    
    links.forEach(link => {
        link.addEventListener('click', () => {
            const tabContentElements = document.querySelectorAll('.js-tabcontent');
            tabContentElements.forEach(tab => tab.classList.remove('active'));
            
            const tabLinks = document.querySelectorAll('.js-open-tabcontent');
            tabLinks.forEach(link => link.classList.remove('active'));

            link.classList.add('active');
            const targetId = link.dataset.tabId;
            const targetContent = document.getElementById(targetId);
            targetContent.classList.add('active');


            if (targetId === 'video') {
                const mediaElement = targetContent.querySelector('iframe, video');
                if (!mediaElement.src) {
                    mediaElement.src = mediaElement.getAttribute('data-src');

                    const handleMediaLoad = function () {
                        const skeleton = targetContent.querySelector('.product-detail__skeleton-box');
                        skeleton.style.display = "none";
                        mediaElement.style.display = "block";
                    };

                    if (mediaElement.tagName === 'IFRAME') {
                        mediaElement.onload = handleMediaLoad;
                    } else if (mediaElement.tagName === 'VIDEO') {
                        mediaElement.onloadeddata = handleMediaLoad;
                    }
                }
            }

            centerItVariableWidth(link,link.parentNode.parentNode);
        })
    })
}

const centerItVariableWidth = (target, outer) => {
    var parentInnerWidth = outer.clientWidth;
    var targetOuterWidth = target.offsetWidth;
    var targetIndex = parseInt(target.dataset.index);
    var sumOfelementWidths = 0;
    var elements = outer.querySelectorAll('.js-open-tabcontent');
    //Just need to add up the width of all the elements before our target. 
    for (var i = 0; i < targetIndex; i++) {
        sumOfelementWidths += elements[i].offsetWidth;
    }
    outer.scrollLeft = Math.max(0, sumOfelementWidths - (parentInnerWidth - targetOuterWidth) / 2)
};